export default __webpack_public_path__ + "static/media/chevron_down.6e2f6eb9.svg";